/**
 * Base URL used for custom emoji previews in places that have no access to the
 * instance context (ProseMirror model conversion, editor input rules).
 *
 * Set by the Instance once the API configuration is known, so that self-hosted
 * instances load custom emoji from their own file server instead of the public CDN.
 */
let customEmojiBase = "https://cdn.revoltusercontent.com";

export function setCustomEmojiBase(mediaUrl: string) {
  customEmojiBase = mediaUrl.replace(/\/$/, "");
}

export function customEmojiUrl(id: string) {
  return `${customEmojiBase}/emojis/${id}`;
}
